import CommonNavbar from '../components/CommonNavbar/CommonNavbar'
import CommonFooter from '../components/CommonFooter/CommonFooter'

import { useState, useEffect } from 'react'
import { Col, Row } from 'react-bootstrap'
import ReactPaginate from 'react-paginate'
import {
  nextPaginationArrow,
  prevPaginationArrow
} from '../../src/components/SvgPaths/SvgPaths'

import { useNavigate } from 'react-router-dom'
import likeicon from '../assets/images/png/like-icon.png'
import { getProducts } from '../services/ProductsServices'
import {
  addProducttoWishlist,
  getWishlistProducts
} from '../services/WishlistServices'
import wishlistSelectedIcon from '../assets/images/png/wishlistSelectedIcon.png'
import { getSubCategory } from '../services/CategoriesService'
import ClearIcon from '../assets/images/png/clear-icon.svg'

import FeatureAdds from '../../src/components/AllProdutcs/FeatureAdds'

const GaonSe = () => {
  const navigate = useNavigate()
  const [productsToBeShown, setProductsToBeShown] = useState(12)
  const [pageNumber, setPageNumber] = useState(1)
  const [products, setProducts] = useState([])
  const [favouriteItems, setFavouriteItems] = useState([])
  const [subCategory, setSubCategory] = useState([])
  const [totalPages, setTotalPages] = useState(0)
  const [subCategoryId, setSubCategoryId] = useState('')
  const [lastPageNumber, setLastPageNumber] = useState(1) // State to store last selected page number

  const getproducts = async () => {
    const res = await getProducts(
      'gaonSe',
      pageNumber,
      productsToBeShown,
      '',
      '',
      '',
      subCategoryId
    )

    if (res) {
      setProducts(res.products)
      const calculatedTotalPages = Math.ceil(
        res.totalProducts / productsToBeShown
      )
      setTotalPages(calculatedTotalPages)
    }
  }

  const getWishlistItems = async () => {
    const tokenitem = localStorage.getItem('token')
    const res = await getWishlistProducts(tokenitem)
    setFavouriteItems(res)
  }

  useEffect(() => {
    getproducts()
    getWishlistItems()
  }, [pageNumber, productsToBeShown, subCategoryId])

  const addToWishlist = async id => {
    const tokenitem = localStorage.getItem('token')
    if (tokenitem) {
      const productId = id
      await addProducttoWishlist(productId, tokenitem)
      getWishlistItems()
    } else {
      localStorage.setItem('path', '/farmer-shop')
      navigate('/signin')
    }
  }

  const isInWishlist = id => {
    return (
      favouriteItems && favouriteItems.some(item => item?.productId?._id === id)
    )
  }

  const handlePageChange = ({ selected }) => {
    setPageNumber(selected + 1)
    setLastPageNumber(selected + 1) // Update last selected page number
  }

  const getSubCategories = async () => {
    const res = await getSubCategory('gaonSe')
    console.log('res for MArttt --->', res)
    setSubCategory(res)
  }

  const handleSubCategoryChange = id => {
    setSubCategoryId(id)
    setPageNumber(1)
  }

  const handleSubCategoryfromBanner = e => {
    setSubCategoryId(e)
    setPageNumber(1)
  }

  useEffect(() => {
    getSubCategories()
  }, [subCategoryId])

  const clearFilters = async () => {
    setSubCategoryId('')
    setPageNumber(1) // Set page number to last selected page
    getproducts()
  }

  return (
    <>
      <div className=' py-5'>
        <div className='container px-sm-5 px-2 '>
          <div>
            <div className=' mb-4'>
              <h1 className='ff_heebo fw-bold fs_2xl'>
                <span className='clr_dark_green'>Gaon Se </span>
              </h1>
            </div>

            <div className='d-flex align-items-center gap-1'>
              <p className='mb-0'>SHOW:</p>
              <input
                className='product-number-input'
                value={productsToBeShown}
                onChange={e => {
                  const inputValue = parseInt(e.target.value)
                  if (inputValue < 6) {
                    setProductsToBeShown(6)
                  } else {
                    setProductsToBeShown(inputValue)
                  }
                }}
                type='number'
              />
            </div>
          </div>
          {/* <FarmShopBanner
          handleSubCategoryfromBanner={handleSubCategoryfromBanner}
        /> */}
          <div className='overflow-x-hidden'>
            <Row>
              <Col className='h-100 side-bar-position top-0 ' lg={3}>
                <div className='d-flex flex-column-reverse flex-lg-column '>
                  <div className='bg-light-green p-3 product-border rounded-3 mt-4 bg-white'>
                    <p className='ff_heebo fs_xsm fw-semibold text-uppercase my-2'>
                      Filter by categories
                    </p>
                    <hr />
                    {subCategory.map((value, index) => (
                      <label
                        key={index}
                        className='d-flex align-items-center gap-1 mt-2 cursor-pointer'
                        onClick={() => handleSubCategoryChange(value?._id)}
                      >
                        <input
                          type='radio'
                          name='adType'
                          value={value?._id}
                          onChange={() => handleSubCategoryChange(value?._id)}
                          checked={subCategoryId === value?._id}
                        />{' '}
                        <p className='rounded-2 ff_heebo mb-0'>{value?.name}</p>
                      </label>
                    ))}

                    <button
                      onClick={clearFilters}
                      className='filter_search_btn fw-medium text-uppercase mt-3 w-100 ff_heebo d-flex align-items-center justify-content-center'
                    >
                      <img className='mt-1' src={ClearIcon} alt='search-icon' />{' '}
                      Clear Filter
                    </button>
                  </div>
                  <FeatureAdds />
                </div>
              </Col>
              <Col lg={9}>
                <div>
                  {products.length === 0 ? (
                    <div className='py-5 mt-4 bg-white rounded-2'>
                      <div className='py-4'>
                        <h2 className='text-center clr_dark_green ff_heebo fw-medium'>
                          No Product found
                        </h2>
                      </div>
                    </div>
                  ) : (
                    <div className='row g-4'>
                      {products.map((item, index) => (
                        <div className='col-md-4 col-sm-6' key={index}>
                          <div className='product-card bg-white rounded-4 shadow-sm position-relative h-100 overflow-hidden d-flex flex-column'>
                            {/* Wishlist Button */}
                            <div
                              className='wishlist-btn position-absolute top-0 end-0 m-2'
                              onClick={() => addToWishlist(item?._id)}
                            >
                              {isInWishlist(item?._id) ? (
                                <img
                                  width={22}
                                  src={wishlistSelectedIcon}
                                  alt='wishlistIcon'
                                />
                              ) : (
                                <img
                                  width={22}
                                  src={likeicon}
                                  alt='wishlistIcon'
                                />
                              )}
                            </div>

                            {/* Discount Badge */}
                            {item?.discountPrice && (
                              <span className='discount-badge position-absolute top-0 start-0 m-2 px-3 py-1 rounded-pill'>
                                {Math.round(
                                  ((item.price - item.discountPrice) /
                                    item.price) *
                                    100
                                )}
                                % OFF
                              </span>
                            )}

                            {/* Product Image */}
                            <div
                              className='text-center flex-grow-1 d-flex align-items-center justify-content-center p-3 cursor_pointer'
                              onClick={() =>
                                navigate(`/product-details/${item?._id}`)
                              }
                            >
                              <img
                                src={
                                  item?.images[0] ||
                                  'https://savr-dev-bucket.s3.amazonaws.com/83b1a7b1-728b-4f45-9615-1b7b86b572b4'
                                }
                                alt={item?.name}
                                className='product-img img-fluid'
                              />
                            </div>

                            {/* Product Info */}
                            <div className='p-3'>
                              <p
                                className='ff_heebo fw-semibold fs-6 text-dark text-capitalize mb-2 cursor_pointer'
                                onClick={() =>
                                  navigate(`/product-details/${item?._id}`)
                                }
                              >
                                {item?.name}
                              </p>
                              <p className='text-muted  mb-0'>
                                {item?.quantity}
                              </p>
                              <div className='d-flex align-items-center justify-content-between'>
                                <p className='fw-bold fs-5 text-success mb-0'>
                                  ₹{item?.discountPrice}
                                </p>

                                <p className='text-muted text-decoration-line-through mb-0'>
                                  ₹{item?.price}
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </Col>
            </Row>
            <div className='d-flex flex-column flex-md-row gap-3 mt-4 align-items-center justify-content-between'>
              <p className='mb-0 ff_heebo fw-medium fs_xsm clr_dark_grey_3'>
                Showing {productsToBeShown} - {products.length} of{' '}
                {products.length} results
              </p>
              <div className='pagination-container'>
                <ReactPaginate
                  previousLabel={prevPaginationArrow}
                  nextLabel={nextPaginationArrow}
                  pageCount={totalPages}
                  onPageChange={handlePageChange}
                  containerClassName={'pagination justify-content-end mb-0'}
                  previousLinkClassName={'pagination__link'}
                  nextLinkClassName={'pagination__link'}
                  pageClassName={
                    'pagination__page d-flex align-items-center justify-content-center clr_dark_grey_3 mx-1 ff_heebo fw-medium fs_xsm'
                  }
                  disabledClassName={'pagination__link--disabled'}
                  activeClassName={
                    'pagination__link--active d-flex align-items-center justify-content-center text-white ff_heebo fw-medium fs_xsm'
                  }
                  forcePage={pageNumber - 1} // Adjust forcePage to reflect zero-based index
                  marginPagesDisplayed={2} // Number of pages displayed at the beginning and end
                  pageRangeDisplayed={2}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default GaonSe
